import { motion } from "motion/react"
import { FormattedMessage } from "react-intl";

export default function PageTwo() {
    return (
        <motion.div
        className="mainScrollBaseContainer"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -50 }}
        transition={{ duration: 0.5 }}
        >
            <div className="centered main heightCenter">
                <div className="horizontal">
                    <div>
                        <div className="featureCard equal">
                            <h2><FormattedMessage id="keyPoint.1"/></h2>
                            <ul>
                                <li><FormattedMessage id="kp1.1"/></li>
                                <li><FormattedMessage id="kp1.2"/></li>
                                <li><FormattedMessage id="kp1.3"/></li>
                            </ul>
                        </div>
                        <div className="featureCard equal">
                            <h2><FormattedMessage id="keyPoint.2"/></h2>
                            <ul>
                                <li><FormattedMessage id="kp2.1"/></li>
                                <li><FormattedMessage id="kp2.2"/></li>
                                <li><FormattedMessage id="kp2.3"/></li>
                            </ul>
                        </div>
                        <div className="featureCard equal">
                            <h2><FormattedMessage id="keyPoint.3"/></h2>
                            <ul>
                                <li><FormattedMessage id="kp3.1"/></li>
                                <li><FormattedMessage id="kp3.2"/></li>
                                <li><FormattedMessage id="kp3.3"/></li>
                            </ul>
                        </div>
                        <div className="featureCard equal">
                            <h2><FormattedMessage id="keyPoint.4"/></h2>
                            <ul>
                                <li><FormattedMessage id="kp4.1"/></li>
                                <li><FormattedMessage id="kp4.2"/></li>
                            </ul>
                        </div>
                    </div>
                    <div>
                        <div className="featureCard equal">
                            <h2><FormattedMessage id="keyPoint.5"/></h2>
                            <ul>
                                <li><FormattedMessage id="kp5.1"/></li>
                                <li><FormattedMessage id="kp5.2"/></li>
                                <li><FormattedMessage id="kp5.3"/></li>
                            </ul>
                        </div>
                        <div className="featureCard equal">
                            <h2><FormattedMessage id="keyPoint.6"/></h2>
                            <ul>
                                <li><FormattedMessage id="kp6.1"/></li>
                                <li><FormattedMessage id="kp6.2"/></li>
                                <li><FormattedMessage id="kp6.3"/></li>
                            </ul>
                        </div>
                        <div className="featureCard equal">
                            <h2><FormattedMessage id="keyPoint.7"/></h2>
                            <ul>
                                <li><FormattedMessage id="kp7.1"/></li>
                                <li><FormattedMessage id="kp7.2"/></li>
                            </ul>
                        </div>
                        <div className="featureCard equal">
                            <h2><FormattedMessage id="keyPoint.8"/></h2>
                            <ul>
                                <li><FormattedMessage id="kp8.1"/></li>
                                <li><FormattedMessage id="kp8.2"/></li>
                                <li><FormattedMessage id="kp8.3"/></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </motion.div>
    );
}